module.exports = __webpack_public_path__ + "media/images/Tealight-fd7a1d70428c837a0a385d609b6f71c8.png";